import { Outlet } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { SideNav } from '@/components/layout/SideNav'
import { OfflineBanner } from '@/components/layout/OfflineBanner'
import { BottomNav } from '@/components/layout/BottomNav'
import { MobileOnboarding } from '@/components/layout/MobileOnboarding'
import { PageTitleProvider } from '@/components/common/PageTitle'
import { TooltipProvider } from '@/components/ui'

/** Sidebar + header + routed content. Mobile collapses the sidebar into a sheet. */
export function AppShell() {
  return (
    <TooltipProvider delayDuration={250}>
      <PageTitleProvider>
      <div className="flex h-full min-h-screen bg-background">
        <SideNav />
        <div className="flex min-w-0 flex-1 flex-col">
          <Header />
          <OfflineBanner />
          {/*
            * pb-28 clears the floating tab bar; lg drops it, because the bar
            * is gone by then.
            *
            * `sm:pt-6`, NOT `sm:py-6`. `py` is shorthand for both ends, and
            * the sm variant comes after the unprefixed `pb-28` in the
            * cascade — so from 640px to 1024px it quietly reset the bottom
            * padding to 24px and the bar covered the last 55px of every
            * page. Below 640 it was right and above 1024 there is no bar,
            * which is why the one band it was wrong in went unnoticed.
            * Measured: the bar wants 79px of clearance and was getting 24.
            */}
          <main className="flex-1 overflow-y-auto px-3 py-4 pb-28 sm:px-6 sm:pt-6 lg:pb-6">
            <div className="mx-auto w-full max-w-[1600px] space-y-5">
              <Outlet />
            </div>
          </main>
        </div>
        <BottomNav />
        <MobileOnboarding />
      </div>
    </PageTitleProvider>
    </TooltipProvider>
  )
}
